<template>
  <div class="model-content">
    <div
      class="model_50"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <div class="img-box">
        <img
          v-if="posterList.lang == 'ug' || !posterList.lang"
          style="width: 100%"
          :src="urlUg"
        />
        <img v-if="posterList.lang == 'zh'" style="width: 100%" :src="urlZh" />
      </div>

      <div class="merchant_qrcode" v-html="posterList.qrcode"></div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode-svg";
export default {
  name: "model_50",
  data() {
    return {
      posterList: {},
      urlUg: require("../../img/poster/model_50_ug.jpg"),
      urlZh: require("../../img/poster/model_50_zh.jpg"),
    };
  },
  created() {
    this.posterList = this.$route.query;
    const svg = new QRCode({
      content: this.$route.query.shipper_qrcode,
      padding: 2,
      width: 69,
      height: 69,
      color: "#000000",
      background: "#ffffff",
      ecl: "M",
    }).svg();
    this.posterList.qrcode = svg;
  },
};
</script>

<style scoped>
.model-content {
  width: 333.33px;
  height: 666.66px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_50 {
  width: 333.33px;
  height: 666.66px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant_qrcode {
  position: absolute;
  bottom: 23px;
  left: 16px;
  width: 69px;
  height: 69px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
}
</style>
